import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AgentApi, AgentApiImpl } from './apis';
import {
    AgentUserWaitingApi,
    AgentUserWaitingApiImpl,
} from './apis/agent-user-waiting-api';
import { ValidationApi, ValidationApiImpl } from './apis/validation-api';
import { MaterialNoveltyApi, MaterialNoveltyApiImpl } from './apis/material-novelty-api';
import { MaterialFormulationApi, MaterialFormulationApiImpl } from './apis/material-formulation-api';
import { MaterialBulkApi, MaterialBulkApiImpl } from './apis/material-bulk-api';

export const agentContainer = new ContainerModule((bind) => {
    bind(AgentApi).to(AgentApiImpl);
    bind(AgentUserWaitingApi).to(AgentUserWaitingApiImpl);
    bind(ValidationApi).to(ValidationApiImpl);
    bind(MaterialNoveltyApi).to(MaterialNoveltyApiImpl);
    bind(MaterialFormulationApi).to(MaterialFormulationApiImpl);
    bind(MaterialBulkApi).to(MaterialBulkApiImpl)
});
